export const jobs = [
  {
    id: "fandisentinel",
    company: "F&I Sentinel",
    role: "Lead Software Engineer",
    period: "February 2026 - Present",
    technologies: [
      "Cursor",
      "Bedrock",
      "AI",
      "Agentic Workflows",
      "React",
      "Python",
      "AWS",
      "Azure",
      "C#",
      "TypeScript",
      "CSS",
      "DynamoDB",
      "S3",
      "SQL",
      "Technical Leadership",
      "Team Organization",
      "Mentorship",
      "Driving Standards",
      "Product Discovery",
      "Cross-Functional Collaboration",
      "Stakeholder Communication",
      "Customer Facing",
    ],
    weight: 1.0,
  },
  {
    id: "amazon",
    company: "Amazon",
    role: "Software Dev Engineer",
    period: "May 2022 - January 2026",
    technologies: [
      "React",
      "Java",
      "AWS",
      "GraphQL",
      "Python",
      "TypeScript",
      "CSS",
      "DynamoDB",
      "S3",
      "SQL",
      "Team Organization",
      "Mentorship",
      "Technical Decision Making",
      "Product Discovery",
      "Cross-Functional Collaboration",
      "Stakeholder Communication",
    ],
    weight: 0.9,
  },
  {
    id: "transact-campus",
    company: "Transact Campus",
    role: "Software Engineer",
    period: "July 2021 - May 2022",
    technologies: [
      "React",
      "C#",
      "AWS",
      "TypeScript",
      "CSS",
      "DocumentDB",
      "CI/CD",
      "Technical Decision Making",
      "Customer & Partner Facing",
      "Cross-Functional Collaboration",
      "Stakeholder Communication",
    ],
    weight: 0.7,
  },
  {
    id: "management-controls",
    company: "Management Controls Inc.",
    role: "Full Stack/Lead UI Engineer",
    period: "September 2020 - July 2021",
    technologies: [
      "Angular",
      "C#",
      "Azure",
      "CSS",
      "SQL",
      "CI/CD",
      "Technical Leadership",
      "Driving Standards",
      "Cross-Functional Collaboration",
      "Stakeholder Communication",
    ],
    weight: 0.6,
  },
  {
    id: "alaska-airlines",
    company: "Alaska Airlines",
    role: "E-Commerce Software Development",
    period: "December 2018 - August 2020",
    technologies: [
      "React",
      "C#",
      "Python",
      "Azure",
      "TypeScript",
      "CSS",
      "DocumentDB",
      "SQL",
      "CI/CD",
      "Customer & Partner Facing",
      "Product Discovery",
      "Cross-Functional Collaboration",
    ],
    weight: 0.8,
  },
];
